/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Scope_Output5Inputs */

const en_svc_mcp_server_development_scope_output5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool surface map`)
};

const ar_svc_mcp_server_development_scope_output5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خريطة سطح الأدوات`)
};

const bn_svc_mcp_server_development_scope_output5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টুল ক্ষেত্র মানচিত্র`)
};

const de_svc_mcp_server_development_scope_output5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool-Oberflächenkarte`)
};

const es_svc_mcp_server_development_scope_output5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa de superficie de herramientas`)
};

const fr_svc_mcp_server_development_scope_output5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte de surface d'outils`)
};

const pt_svc_mcp_server_development_scope_output5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa de superfície de ferramentas`)
};

const zh_svc_mcp_server_development_scope_output5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工具范围地图`)
};

const tr_svc_mcp_server_development_scope_output5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Araç yüzeyi haritası`)
};

const ru_svc_mcp_server_development_scope_output5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карта поверхности инструментов`)
};

const pl_svc_mcp_server_development_scope_output5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa powierzchni narzędzi`)
};

/**
* | output |
* | --- |
* | "Tool surface map" |
*
* @param {Svc_Mcp_Server_Development_Scope_Output5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_scope_output5 = /** @type {((inputs?: Svc_Mcp_Server_Development_Scope_Output5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Scope_Output5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_scope_output5(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_scope_output5(inputs)
	if (locale === "de") return de_svc_mcp_server_development_scope_output5(inputs)
	if (locale === "es") return es_svc_mcp_server_development_scope_output5(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_scope_output5(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_scope_output5(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_scope_output5(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_scope_output5(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_scope_output5(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_scope_output5(inputs)
	return en_svc_mcp_server_development_scope_output5(inputs)
});
export { svc_mcp_server_development_scope_output5 as "svc_mcp-server-development_SCOPE_output" }